export const LocalStorage = {
  SkipTutorial: 'skipTutorial',
  SkipDownloadNotification: 'skipDownloadNotification',
};

export const SkipTutorial = {
  Yes: 'yes',
};
